import Tween from "tween.ts"
import Animation from "./Animation";
import HowToPlayText from "../entities/howtoplay/firstPart/TextOfHowToPlay";


export default class HTPTextAnimation extends Animation {

  constructor(HTPText: HowToPlayText, scale: number, onComp: () => void) {
    super();
    new Tween.Tween(HTPText.scale)
      .to({ x: scale, y: scale }, 1500)
      .easing(Tween.Easing.Elastic.Out)
      .onComplete(() => onComp())
      .start();
  }
}